import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.SimpleCaseStudy.heading',
    defaultMessage: 'Case Studies'
  },
  lastAdded: {
    id: 'views.SimpleCaseStudy.lastAdded',
    defaultMessage: 'OSTATNIO DODANE'
  },
  earlier: {
    id: 'views.SimpleCaseStudy.earlier',
    defaultMessage: 'WCZEŚNIEJSZE'
  },
  categories: {
    id: 'views.SimpleCaseStudy.categories',
    defaultMessage: 'KATEGORIE'
  },
  nothingToShow: {
    id: 'views.SimpleCaseStudy.nothingToShow',
    defaultMessage: 'Brak artykułów do wyświetlenia'
  },
  taxonomyAll: {
    id: 'views.SimpleCaseStudy.categories.all',
    defaultMessage: 'Wszystkie'
  },
  showMore: {
    id: 'views.SimpleCaseStudy.showMore',
    defaultMessage: 'WYŚWIETL WIĘCEJ...'
  }
});



// WEBPACK FOOTER //
// ./src/views/SimpleCaseStudy/SimpleCaseStudyView.intl.js